import {GET_SIGNED_FILES_INFO, LOG_OUT} from "../actions/types";

const INITIAL_STATE = {
  entries: null,
  total: 0
};

const privateFileList= (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_SIGNED_FILES_INFO:
      return {...state, ...action.payload.privateFileList};
    case LOG_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
};
export default privateFileList;